import { type FC, useState, useCallback, useEffect } from 'react';

import { SbSharedFavoritesNudgeToastWatcher } from './SbSharedFavoritesNudgeToastWatcher';

type Props = {
    userId: string;
    isItemFavoritingVariant: boolean;
};

const SbSharedFavoritesNudgeToast: FC<Props> = ({ userId, isItemFavoritingVariant }) => {
    const [startWatch, setStartWatch] = useState(false);

    const handleStopWatch = useCallback(() => {
        setStartWatch(false);
    }, []);

    useEffect(() => {
        if (isItemFavoritingVariant) {
            setStartWatch(true);
        }
    }, [isItemFavoritingVariant]);

    if (!startWatch) {
        return null;
    }

    return <SbSharedFavoritesNudgeToastWatcher userId={userId} onStopWatch={handleStopWatch} />;
};

export { SbSharedFavoritesNudgeToast };
